import MyAppCard from './MyAppCard';

export default MyAppCard;